<template>
    <div>
        <div class="page-breadcrumb d-print-none">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title" v-if="component === 'members'"><i class="fas fa-seedling"></i> Members</h4>
                    <h4 class="page-title" v-else-if="component === 'growers'"><i class="fas fa-seedling"></i> Partners
                    </h4>
                    <div class="d-flex align-items-center">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link :to="{name: 'dashboard'}">Home</router-link>
                                </li>
                                <li aria-current="page" class="breadcrumb-item active">
                                    <strong v-if="component === 'members'">Members</strong>
                                    <strong v-if="(['growers', 'addgrower']).includes(component)">Partners</strong>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div class="col-7 align-self-center">
                    <div class="d-flex no-block justify-content-end align-items-center">
                        <template v-if="component == 'view-member'">
                            <router-link :to="{name: 'members'}"
                                         class="btn btn-secondary waves-effect waves-light">
                                <i class="fas fa-arrow-left"></i>&nbsp; Back
                            </router-link>
                        </template>
                        <template v-if="component == 'view-member-card'">
                            <a @click="back" class="btn btn-secondary waves-effect waves-light"
                               href="javascript:void(0)">
                                <i class="fas fa-arrow-left"></i>&nbsp; Back
                            </a>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "MarketplaceLayout",
        data() {
            return {
                component: null,
                selected_catalog: null,
                selected_filter: null,
            }
        },
        watch: {
            $route(to, from) {
                this.component = to.name;
            }
        },
        created() {
            this.component = this.$route.name;
        },
        methods: {
            back() {
                this.$router.go(-1);
            }
        }

    }
</script>

<style scoped>

</style>
